import React from "react";
import ReactDOM from "react-dom/client";

import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";

import "./style/index.css";
import "./style/style.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import packageJson from "../package.json";


const root = ReactDOM.createRoot(document.getElementById("root"));

export const APP_VERSION = packageJson.version;


root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
